/* ------------------------------------*\
	VARIABLE DECLARATION
\*------------------------------------*/
common = {

	setupCommon: function () {
		utils.setupHeight();

		if (utils.enableDebug) {
			utils.setupDebug();
		}
		utils.setupLazyLoadImages();
	},
};


$(window).on('load', () => {
	/*------------------------------------*\
		CALL TO FUNCTIONS
	\*------------------------------------*/
	console.log(
		'<!-- ------------------------------------------------------ -->\n' +
		'<!-- Code by AMA, https://ama.work (2023) 					-->\n' +
		'<!-- Developer: David Penuela (http://davidpenuela.com)		-->\n' +
		'<!-- info@ama.work 											-->\n' +
		'<!-- ------------------------------------------------------ -->\n');

	common.setupCommon();

	if (utils.isHome()) {
		home.setupPage();
	} else if (utils.isSingleProjectPage()) {
		project.setupPage();
	} else if (utils.isProductPage() || utils.isShopPage()) {

		if (!utils.isMobile() && !utils.isSmallScreen()) {
			home.setupCursorHome();
		}
	}
});
